var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('div',{staticClass:"container pt-5"},[_vm._t("default",null,{"slot":""})],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }